import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "storageLimit",
})
export class StorageLimitPipe implements PipeTransform {
  transform(limit: number): string {
    if (limit > 100) {
      return `${limit / 1000} GB`;
    }
    return `${limit} MB`;
  }
}
